import { render } from "./AdminAuthComponent.vue?vue&type=template&id=35e968f0"
import script from "./AdminAuthComponent.vue?vue&type=script&lang=js"
export * from "./AdminAuthComponent.vue?vue&type=script&lang=js"

import "./AdminAuthComponent.vue?vue&type=style&index=0&id=35e968f0&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__